const wishlistEmptyIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 67.949 67.949" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M62.49 11.239c-7.39-7.388-19.412-7.388-26.8 0l-1.716 1.715-1.715-1.715c-7.388-7.389-19.411-7.389-26.799 0-7.238 7.238-7.285 18.711-.109 26.688 6.545 7.273 25.848 22.986 26.667 23.651a2.986 2.986 0 0 0 1.89.672l.065-.001c.688.032 1.381-.204 1.955-.671.819-.665 20.124-16.378 26.671-23.652 7.175-7.976 7.128-19.449-.109-26.687zm-4.351 22.674c-5.103 5.669-19.13 17.361-24.166 21.51-5.036-4.148-19.06-15.839-24.162-21.509-5.006-5.564-5.053-13.488-.109-18.432 2.525-2.524 5.841-3.787 9.157-3.787s6.632 1.262 9.157 3.787l3.772 3.772a2.902 2.902 0 0 0 1.609.811 3.006 3.006 0 0 0 2.76-.81l3.774-3.773c5.051-5.049 13.267-5.048 18.315 0 4.944 4.944 4.897 12.868-.107 18.431z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>';
const wishlistFillIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M471.383 44.578C444.879 15.832 408.512 0 368.973 0c-29.555 0-56.621 9.344-80.45 27.77C276.5 37.07 265.605 48.45 256 61.73c-9.602-13.277-20.5-24.66-32.527-33.96C199.648 9.344 172.582 0 143.027 0c-39.539 0-75.91 15.832-102.414 44.578C14.426 72.988 0 111.801 0 153.871c0 43.3 16.137 82.938 50.781 124.742 30.992 37.395 75.535 75.356 127.117 119.313 17.614 15.012 37.579 32.027 58.309 50.152A30.023 30.023 0 0 0 256 455.516c7.285 0 14.316-2.641 19.785-7.43 20.73-18.129 40.707-35.152 58.328-50.172 51.575-43.95 96.117-81.906 127.11-119.305C495.867 236.81 512 197.172 512 153.867c0-42.066-14.426-80.879-40.617-109.289zm0 0" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>';
const wishlistPopupCloseIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.00006 7.00007L16 0L18 2L11 9.00006L18 16L16 18L9.00006 11L2 18L0 16L7.00007 9.00006L0 2L2 0L9.00006 7.00007Z" fill="#161616"/></svg>';
const wishlistDeleteIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M1871 5109 c-128 -25 -257 -125 -311 -241 -37 -79 -50 -146 -50 -259 l0 -89 -389 0 c-222 0 -411 -4 -442 -10 -187 -36 -330 -184 -361 -376 -30 -181 66 -371 231 -458 l69 -36 6 -58 c4 -31 65 -763 136 -1627 72 -863 134 -1587 139 -1608 36 -155 177 -295 335 -332 91 -22 2561 -22 2652 0 158 37 299 177 335 332 5 21 67 745 139 1608 71 864 132 1596 136 1627 l6 58 69 36 c165 87 261 277 231 458 -31 192 -174 340 -361 376 -31 6 -220 10 -442 10 l-389 0 0 89 c0 48 -5 112 -10 142 -34 180 -179 325 -359 359 -66 12 -1306 12 -1370 -1z m1359 -309 c60 -31 80 -78 80 -190 l0 -90 -750 0 -750 0 0 90 c0 110 20 159 78 189 36 19 60 20 670 21 615 0 634 -1 672 -20z m1200 -600 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -39 -20 -55 -20 -1870 -20 -1815 0 -1831 0 -1870 20 -45 23 -80 80 -80 130 0 48 35 107 78 129 36 20 65 20 1870 21 1818 0 1833 0 1872 -20z m-236 -622 c-2 -24 -63 -747 -134 -1606 -140 -1694 -129 -1598 -193 -1646 l-28 -21 -1279 0 -1279 0 -28 21 c-64 48 -53 -48 -193 1646 -71 859 -132 1582 -134 1606 l-6 42 1640 0 1640 0 -6 -42z"></path><path d="M1587 3299 c-25 -13 -45 -34 -58 -62 l-21 -43 76 -1234 c85 -1381 76 -1299 155 -1340 51 -25 91 -25 142 0 27 14 46 34 60 63 l21 43 -76 1234 c-85 1381 -76 1299 -155 1340 -50 25 -95 25 -144 -1z"></path><path d="M2488 3299 c-23 -12 -46 -35 -58 -59 -20 -39 -20 -57 -20 -1280 0 -1224 0 -1241 20 -1280 23 -45 80 -80 130 -80 50 0 107 35 130 80 20 39 20 56 20 1280 0 1224 0 1241 -20 1280 -37 73 -127 99 -202 59z"></path><path d="M3387 3299 c-77 -41 -68 37 -153 -1339 l-76 -1234 21 -43 c14 -29 33 -49 60 -63 51 -25 91 -25 142 0 79 41 70 -41 155 1340 l76 1234 -21 43 c-37 75 -127 103 -204 62z"></path></g></svg>';
const wishlistLikeEmptyIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 478.2 478.2" style="" xml:space="preserve" class=""><g><path d="M457.575 325.1c9.8-12.5 14.5-25.9 13.9-39.7-.6-15.2-7.4-27.1-13-34.4 6.5-16.2 9-41.7-12.7-61.5-15.9-14.5-42.9-21-80.3-19.2-26.3 1.2-48.3 6.1-49.2 6.3h-.1c-5 .9-10.3 2-15.7 3.2-.4-6.4.7-22.3 12.5-58.1 14-42.6 13.2-75.2-2.6-97-16.6-22.9-43.1-24.7-50.9-24.7-7.5 0-14.4 3.1-19.3 8.8-11.1 12.9-9.8 36.7-8.4 47.7-13.2 35.4-50.2 122.2-81.5 146.3-.6.4-1.1.9-1.6 1.4-9.2 9.7-15.4 20.2-19.6 29.4-5.9-3.2-12.6-5-19.8-5h-61c-23 0-41.6 18.7-41.6 41.6v162.5c0 23 18.7 41.6 41.6 41.6h61c8.9 0 17.2-2.8 24-7.6l23.5 2.8c3.6.5 67.6 8.6 133.3 7.3 11.9.9 23.1 1.4 33.5 1.4 17.9 0 33.5-1.4 46.5-4.2 30.6-6.5 51.5-19.5 62.1-38.6 8.1-14.6 8.1-29.1 6.8-38.3 19.9-18 23.4-37.9 22.7-51.9-.4-8.1-2.2-15-4.1-20.1zm-409.3 122.2c-8.1 0-14.6-6.6-14.6-14.6V270.1c0-8.1 6.6-14.6 14.6-14.6h61c8.1 0 14.6 6.6 14.6 14.6v162.5c0 8.1-6.6 14.6-14.6 14.6h-61v.1zm383.7-133.9c-4.2 4.4-5 11.1-1.8 16.3 0 .1 4.1 7.1 4.6 16.7.7 13.1-5.6 24.7-18.8 34.6-4.7 3.6-6.6 9.8-4.6 15.4 0 .1 4.3 13.3-2.7 25.8-6.7 12-21.6 20.6-44.2 25.4-18.1 3.9-42.7 4.6-72.9 2.2h-1.4c-64.3 1.4-129.3-7-130-7.1h-.1l-10.1-1.2c.6-2.8.9-5.8.9-8.8V270.1c0-4.3-.7-8.5-1.9-12.4 1.8-6.7 6.8-21.6 18.6-34.3 44.9-35.6 88.8-155.7 90.7-160.9.8-2.1 1-4.4.6-6.7-1.7-11.2-1.1-24.9 1.3-29 5.3.1 19.6 1.6 28.2 13.5 10.2 14.1 9.8 39.3-1.2 72.7-16.8 50.9-18.2 77.7-4.9 89.5 6.6 5.9 15.4 6.2 21.8 3.9 6.1-1.4 11.9-2.6 17.4-3.5.4-.1.9-.2 1.3-.3 30.7-6.7 85.7-10.8 104.8 6.6 16.2 14.8 4.7 34.4 3.4 36.5-3.7 5.6-2.6 12.9 2.4 17.4.1.1 10.6 10 11.1 23.3.4 8.9-3.8 18-12.5 27z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg>';
const wishlistLikeFillIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 511.999 511.999" style="" xml:space="preserve" class=""><g><path d="M15.34 224.948c-8.365 0-15.146 6.782-15.146 15.146v222.458c0 8.365 6.782 15.146 15.146 15.146h91.253v-252.75H15.34zM511.805 308.587c0-19.227-10.331-36.087-25.733-45.321a52.504 52.504 0 0 0 9.362-29.985c0-29.113-23.686-52.799-52.799-52.799H331.177c3.416-15.48 8.088-38.709 11.341-63.026 8.466-63.281 2.68-98.376-18.207-110.445-13.022-7.523-27.062-9.049-39.534-4.301-9.635 3.67-22.647 12.693-30.062 34.838l-29.294 76.701c-14.851 36.677-60.33 75.182-88.535 96.473V484.4C189.16 502.716 243.708 512 299.358 512h121.446c29.113 0 52.799-23.686 52.799-52.799a52.481 52.481 0 0 0-7.93-27.804c17.601-8.572 29.759-26.646 29.759-47.503a52.504 52.504 0 0 0-9.362-29.985c15.404-9.234 25.735-26.095 25.735-45.322z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>';
// common function START
const setCookie = (cname, cValue, exDays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cValue + ";" + expires + ";path=/";
};
const getCookie = cname => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
};
const getMainButtonClass = (buttonSty) => {
    let btnClass = '';
    if(buttonSty){
        if(buttonSty == 1){
            btnClass = 'tt-icon-border';
        }else if(buttonSty == 2){
            btnClass = 'tt-border';
        }else if(buttonSty == 3){
            btnClass = 'tt-icon-fill';
        }else if(buttonSty == 4){
            btnClass = 'tt-fill';
        }else if(buttonSty == 5){
            btnClass = 'tt-icon-text';
        }else if(buttonSty == 6){
            btnClass = 'tt-text';
        }else if(buttonSty == 7){
            btnClass = 'tt-only-icon';
        }
    }
    return btnClass;
}
const formatMoney = (t, e=window.money_format)=> {
    function o(t, e) {
      return void 0 === t ? e : t
    }
    function i(t, e, i, r) {
      if (e = o(e, 2),
        i = o(i, ","),
        r = o(r, "."),
        isNaN(t) || null == t)
        return 0;
      t = (t / 100).toFixed(e);
      var n = t.split(".");
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? r + n[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = ""
    , n = /\{\{\s*(\w+)\s*\}\}/
    , a = e || "â‚¹ {{amount}}";
    switch (a.match(n)[1]) {
      case "amount":
      r = i(t, 2);
      break;
      case "amount_no_decimals":
      r = i(t, 0);
      break;
      case "amount_with_comma_separator":
      r = i(t, 2, ".", ",");
      break;
      case "amount_with_space_separator":
      r = i(t, 2, " ", ",");
      break;
      case "amount_with_period_and_space_separator":
      r = i(t, 2, " ", ".");
      break;
      case "amount_no_decimals_with_comma_separator":
      r = i(t, 0, ".", ",");
      break;
      case "amount_no_decimals_with_space_separator":
      r = i(t, 0, " ");
      break;
      case "amount_with_apostrophe_separator":
      r = i(t, 2, "'", ".")
    }
    return a.replace(n, r)
}
// Popup & Tost creation
const showToastMsg = async (handle, isLocal = false) => {
    let notificationSetting = window.wishlistMetafields.notification_setting;
    let notificationEnable = window.wishlistMetafields.show_notification_popup;
    let toastDuration = notificationSetting.duration;
    let className = notificationSetting.notificationPlacement;
    let brandEnable = notificationSetting.enableBranding;
    let brandText = notificationSetting.brandText;
    if(notificationEnable == 0){
        return false;
    }
    let product = await fetch(`/products/${handle}.js`); 
    product = await product.json();
    let content = {
        src: product.featured_image,
        title: product.title
    }
    let divEle = document.createElement('DIV');
    divEle.setAttribute('class',`wishlist-toast-msg-wrap tt-position ${className}`);
    let brandHtml = '';
    if(brandEnable == 1){
        brandHtml = `
            <p class="wishlist-branding-wrap wishlist-p-tag">${brandText}</p>
        `;
    }
    let msg = `<strong>${content.title}</strong> has been added${isLocal ? '' : ' to ' + content.listName } successfully`;
    if(isLocal && window.wishlistMsgWithoutCategory){
        msg = window.wishlistMsgWithoutCategory;
        msg = msg.replace('##',content.title)
    }
    if(!isLocal && window.wishlistMsgWithCategory){
        msg = window.wishlistMsgWithoutCategory;
        msg.replace('##',content.title);
        msg = msg.replace('$$',content.listName);
    }
    divEle.innerHTML = `
        <div class="wishlist-toast-msg">
            <div class="left-side-img">
                <img src=${content.src} alt=${content.title} />
            </div>
            <div class="right-side-content">
                <p class="wishlist-product-toast-msg wishlist-p-tag">${msg}</p>
                ${brandHtml}
            </div>
        </div>
    `;
    document.body.append(divEle);
    setTimeout(()=>{
        let allToastEle = document.querySelectorAll('.wishlist-toast-msg-wrap');
        allToastEle.forEach(ele=>{
            ele.remove();
        })
    },Number(toastDuration) * 1000);
};
const wishlistPopupOpen = (flag=false) => {
    let module = window.wishlistMetafields.button_setting.wishlist_module;
    let popupWrap = document.querySelector(".tt-wishlist-details-popup");
    if(module == 'drawer'){
        popupWrap.classList.add('drawer');
    }
    if(flag){
        popupWrap.classList.remove('active');
        document.body.classList.remove('tt-overflow-hidden');
    }else{
        popupWrap.classList.add('active');
        document.body.classList.add('tt-overflow-hidden');
    }
};
const setWishlistAPIData = async () => {
    let module = window.wishlistMetafields.button_setting.wishlist_module;
    let category_enable = window.wishlistMetafields.category_enable;
    let empty_wishlist = window.wishlistMetafields.language2.empty_wishlist;
    let fontSizeMultipler = 1;
    if(module == 'page'){
        fontSizeMultipler = 0.75;
    }
    let mainWrap = document.querySelector(".tt-wishlist-details-main");
    mainWrap.setAttribute('style',`--tt-wishlist-font-multipler:${fontSizeMultipler};`);
    let contentWrap = mainWrap.querySelector(".tt-wishlist-details-content");
    let tabHeader = '';
    let tabContent = '';
    let count = 0;
    let categoriesDetails = await getCategoriesDetailsApi();
    if(categoriesDetails.status == 200){
        if(categoriesDetails.data && categoriesDetails.data.length > 0){
            let newCategory = categoriesDetails.data;
            if(!category_enable && window.customerExist){
                categoriesDetails.data.forEach((category,index)=>{
                    if(index != 0){
                        newCategory[0].details = newCategory[0].details.concat(category.details);
                        category.details = [];
                    }
                });
            }
            newCategory.forEach((category,index)=>{
                let categoryRemoveBtn = `
                    <button type="button" class="tt-category-remove" data-cid="${category.category_id}">
                        ${wishlistDeleteIcon}
                    </button>
                `;
                if(window.isWishlistSharedPage){
                    categoryRemoveBtn = '';
                }
                tabHeader += `
                    <li class="${index == 0 ? 'active': ''}" data-tab="tab${index}">
                        <button type="button" class="tt-tab-title" data-tab="tab${index}">${category.category_name}</button>
                        ${categoryRemoveBtn}
                    </li>
                `;
                let productList = '';
                category.details.forEach(product=>{
                    count++;
                    productList += `
                        <div class="tt-product-list" data-handle="${product.handle}">
                        </div>
                    `;
                })
                if(productList == ''){
                    productList = `<p style="text-align:center;">
                        ${empty_wishlist}
                    </p>`;
                }
                tabContent += `
                    <div class="${index == 0 ? 'active': ''} tab-content-inner-wrap" data-tab="tab${index}">
                        ${productList}
                    </div>
                `;
            });
            contentWrap.innerHTML = `
                <ul class="tt-tab-header-wrap">${tabHeader}</ul>
                <div class="tt-tab-content-wrap">${tabContent}</div>
            `;
            updateProductContent();
        }else{
            contentWrap.innerHTML = `
                <p style="text-align:center;">
                    ${empty_wishlist}
                </p>
            `;
        }
    }else{
        contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `;
    }
    if(!category_enable && window.customerExist){
        let tabHeaderEle = document.querySelector(".tt-tab-header-wrap");
        if(tabHeaderEle){
            tabHeaderEle.classList.add('tt-hide');
        }
    }
    wishlistUpdateCount(count);
}
const setWishlistLocalData = async (flag) => {
    let module = window.wishlistMetafields.button_setting.wishlist_module;
    let empty_wishlist = window.wishlistMetafields.language2.empty_wishlist;
    let fontSizeMultipler = 1;
    if(module == 'page'){
        fontSizeMultipler = 0.75;
    }
    let count = 0;
    let mainWrap = document.querySelector(".tt-wishlist-details-main");
    mainWrap.setAttribute('style',`--tt-wishlist-font-multipler:${fontSizeMultipler};`)
    let contentWrap = mainWrap.querySelector(".tt-wishlist-details-content");
    let tabContent = '';
    let productsData = getCookie('wishlist');
    if(productsData){
        productsData = JSON.parse(productsData);
        if(productsData && productsData.length > 0){
            productsData.forEach((product,index)=>{
                count++; 
                tabContent += `
                    <div class="tt-product-list" data-handle="${product.p_handle}">
                    </div>
                `;
            });
            if(tabContent == ''){
                tabContent = `<p style="text-align:center;">
                    ${empty_wishlist}
                </p>`;
            }
            contentWrap.innerHTML = `
                <div class="tt-tab-content-wrap">
                    <div class="active tab-content-inner-wrap" data-tab="tab0">
                        ${tabContent}
                    </div>
                </div>
            `;
            updateProductContent();
        }else{
            contentWrap.innerHTML = `
                <p style="text-align:center;">
                    ${empty_wishlist}
                </p>
            `;
        }
    }else{
        contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `;
    }
    if(flag){
        contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `;
    }
    wishlistUpdateCount(count);
}
const wishlistUpdateCount = (count) => {
    let countWrap = document.querySelector(".wishlist-page-widget .wishlist-total-count");
    if(countWrap){
        if(!count){
            count = 0;
        }
        countWrap.innerHTML = count;
        if(count == 0){
          document.querySelectorAll(".wishlist-page-widget .wishlist-total-count").forEach(function(e) {
                e.style.display = "none";
          }) 
        }else{
          document.querySelectorAll(".wishlist-page-widget .wishlist-total-count").forEach(function(e) {
              e.style.display = "flex";
              e.innerHTML = count;
          })
        }
    }
}
const wishlistContent = () => {
    if(this.customerExist){
        setWishlistAPIData();
    }else if(window.wishlistMetafields.guest_wishlist == 1){
        setWishlistLocalData();
    }else{
        setWishlistLocalData(true);
    }
}
const updateProductContent = (flag=false,isTrending) => {
    let allProductArr = [];
    let allProducts = document.querySelectorAll(".tt-product-list");
    allProducts.forEach(ele=>{
        if(isTrending){
            allProductArr.push(ele);
        }else{
            if(!ele.closest('.tt-wishlist-trending-wrap')){
                allProductArr.push(ele);
            }
        }
    });
    fetchProductDetails(allProductArr,flag);
}
const fetchProductDetails = async (products,flag) => {
    if(products && products.length > 0){
        let language2 = window.wishlistMetafields.language2;
        let atcText = language2.btn_move_to_cart;
        let oosText = language2.btn_oos_text;

        let atcColor = language2.btn_text_color;
        let oosColor = language2.oos_text_color;
        let atcColorBg = language2.btn_bg_color;
        let oosColorBg = language2.oos_bg_color;

        let currenrProduct = products.pop();
        let pHandle = currenrProduct.getAttribute('data-handle');
        currenrProduct.setAttribute('style',`--tt-atc-btn-color:${atcColor}; --tt-atc-btn-bg:${atcColorBg}; --tt-oos-btn-color:${oosColor}; --tt-oos-btn-bg:${oosColorBg};`)
        let product = await fetch(`/products/${pHandle}.js`); 
        product = await product.json();
        let variantHtml = '';
        let defaultVariant = false;
        let atcButton = true;
        if(!product.available){
            atcButton = false;
            defaultVariant = true;
        }
        
        // if(product.available){
            product.variants.forEach((variant,index)=>{
                if(variant.title == 'Default Title'){
                    defaultVariant = true;
                    if(!variant.available){
                        atcButton = false;
                    }
                }
                if(window.wishlistMetafields.enable_variants == 0){
                    defaultVariant = true;
                }
                variantHtml += `
                    <option value="${variant.id}" data-price="${variant.price}" data-available=${variant.available} ${variant.available ? '': ''}>${variant.title}</option>
                `;
            });
        // }
        
        let atcButtonHtml = '';
        if(atcButton){
          if(product.variants.length > 1){
            var selection_html = ` <span class="flex gap-2 text-xs text-[#D49098] whitespace-nowrap productdrawer-variant-container">`


                product.variants.forEach((variant,index)=>{
                  if(variant.title != 'Default Title'){
                    var cls = "";
                    if(!variant.available){
                    cls = "ctm_disabled ";
                    
                    }
                    if(index == 0){
                      cls += ' active-variant' 
                    }
                    selection_html += 
                      `<div class="flex justify-center px-2.5 py-1 rounded-3xl border border-[#D49098] bg-opacity-60 font-next-art-regular sm:text-base text-xs productdrawer-variant cursor-pointer ${cls}" data-id="${variant.id}">
                       ${variant.title}
                        <span class="hidden productdrawer-product-price">
                         <span class="productdrawer-product-price-discount">${(formatMoney(variant.price)).replace('₹','')}</span>
                          <span class="productdrawer-product-price-original">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                        </span>
                      </div>`
                  }
                })          

           selection_html += `</span><span class="flex gap-2 text-xs whitespace-nowrap productdrawer-variant-price-container">`;

           product.variants.forEach((variant,index)=>{
            if(variant.title != 'Default Title'){
              if(index == 0){
                selection_html += `  <span class="product-price-information flex sm:gap-2 gap-1 start sm:items-end items-center price sale is-visible" data-id="${variant.id}">
                       
                          <span class="lg:text-2xl md:text-lg text-base capitalize font-next-art-bold new-price">${(formatMoney(variant.price)).replace('₹','')}</span>`
                  
                       if(variant.compare_at_price > variant.price){
                         selection_html += `   <span class="sm:text-lg text-sm text-zinc-500 font-next-art-regular line-through old-price">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                        
                          
                         
                          <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                              &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                            </span> `;
                       } 
                       
                       selection_html += `
                        <br>   
                    </span>`
                }else{
                  selection_html += `  <span class="product-price-information flex sm:gap-2 gap-1 start sm:items-end items-center price sale" data-id="${variant.id}">
                         
                            <span class="lg:text-2xl md:text-lg text-base capitalize font-next-art-bold new-price">${(formatMoney(variant.price)).replace('₹','')}</span>`
                    
                         if(variant.compare_at_price > variant.price){
                           selection_html += `   <span class="sm:text-lg text-sm text-zinc-500 font-next-art-regular line-through old-price">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                          
                            
                           
                            <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                                &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                              </span> `;
                         } 
                         
                         selection_html += `
                          <br>   
                      </span>`
                }
              }
            }) 

       
          
          selection_html += `</span>
                <button type="button" class="tt-product-atc-main btn product__submit__add shopify-payment-button__button--unbranded atc-btn cstm_atd_all_page justify-center sm:px-5 px-2 py-2.5 sm:text-lg text-sm sm:h-[50px] font-bold text-white whitespace-nowrap bg-gradient-to-l from-[#AD5162] to-[#D49098] hover:bg-gradient-to-br rounded-[43px] max-md:px-5" data-id=${product.id}>
                    <span data-add-to-cart-text="">
                     ${atcText}
                     </span>
                   <svg height="18" width="18" class="svg-loader"><circle r="7" cx="9" cy="9"></circle><circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle></svg>
                </button>
                <button  style="width: 100%;" type="button" class=" shopify-payment-button__button--unbranded atc-btn cstm_atd_all_page justify-center sm:px-5 px-2 py-2.5 sm:text-lg text-sm sm:h-[50px] font-bold text-white whitespace-nowrap bg-gradient-to-l from-[#AD5162] to-[#D49098] hover:bg-gradient-to-br rounded-[43px] max-md:px-5 product-upsell__errors">
                   <span class="errors limit-msg font-gotham-bold">
                     Max. Qty Reached
                   </span>
               </button>`
            atcButtonHtml = selection_html;
          }else{

               var selection_html = ` <span class="flex gap-2 text-xs text-[#D49098] whitespace-nowrap productdrawer-variant-container">`


                product.variants.forEach((variant,index)=>{
                  if(variant.title != 'Default Title'){
                    var cls = "";
                    if(!variant.available){
                    cls = "ctm_disabled ";
                    }
                   if(index == 0){
                      cls += ' active-variant' 
                    }
                    
                    selection_html += 
                      `<div class="flex justify-center px-2.5 py-1 rounded-3xl border border-[#D49098] bg-opacity-60 font-next-art-regular sm:text-base text-xs productdrawer-variant cursor-pointer ${cls}" data-id="${variant.id}">
                       ${variant.title}
                        <span class="hidden productdrawer-product-price">
                         <span class="productdrawer-product-price-discount">${(formatMoney(variant.price)).replace('₹','')}</span>`;
                        if(variant.compare_at_price > variant.price){
                          selection_html += `
                          <span class="productdrawer-product-price-original">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                          <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                            &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                          </span>`
                        }
                         
                         selection_html += `  
                        </span>
                      </div>`
                  }
                })          

           selection_html += `</span><span class="flex gap-2 text-xs whitespace-nowrap productdrawer-variant-price-container">`;

           product.variants.forEach((variant,index)=>{
            if(variant.title != 'Default Title'){
               if(index == 0){
                 selection_html += `  <span class="product-price-information flex sm:gap-2 gap-1 start sm:items-end items-center price sale is-visible" data-id="${variant.id}">
                   
                      <span class="lg:text-2xl md:text-lg text-base capitalize font-next-art-bold new-price">${(formatMoney(variant.price)).replace('₹','')}</span>
                    
                      <span class="sm:text-lg text-sm text-zinc-500 font-next-art-regular line-through old-price">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                    
                      
                     
                      <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                          &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                        </span> 
                    <br>   
                </span>`
               }else{

                 selection_html += `  <span class="product-price-information flex sm:gap-2 gap-1 start sm:items-end items-center price sale" data-id="${variant.id}">
                   
                      <span class="lg:text-2xl md:text-lg text-base capitalize font-next-art-bold new-price">${(formatMoney(variant.price)).replace('₹','')}</span>
                    
                      <span class="sm:text-lg text-sm text-zinc-500 font-next-art-regular line-through old-price">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                    
                      
                     
                      <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                          &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                        </span> 
                    <br>   
                </span>`
                 
               } 
              }
            }) 
            selection_html +=  `</span>
                <button type="button" class="tt-product-atc-main btn product__submit__add shopify-payment-button__button--unbranded atc-btn cstm_atd_all_page justify-center sm:px-5 px-2 py-2.5 sm:text-lg text-sm sm:h-[50px] font-bold text-white whitespace-nowrap bg-gradient-to-l from-[#AD5162] to-[#D49098] hover:bg-gradient-to-br rounded-[43px] max-md:px-5" data-id=${product.id}>
                     <span data-add-to-cart-text="">
                     ${atcText}
                     </span>
                   <svg height="18" width="18" class="svg-loader"><circle r="7" cx="9" cy="9"></circle><circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle></svg>
                </button>
                <button  style="width: 100%;" type="button" class=" shopify-payment-button__button--unbranded atc-btn cstm_atd_all_page justify-center sm:px-5 px-2 py-2.5 sm:text-lg text-sm sm:h-[50px] font-bold text-white whitespace-nowrap bg-gradient-to-l from-[#AD5162] to-[#D49098] hover:bg-gradient-to-br rounded-[43px] max-md:px-5 product-upsell__errors">
                   <span class="errors limit-msg font-gotham-bold">
                     Max. Qty Reached
                   </span>
               </button>
            `; 
            atcButtonHtml = selection_html;
          }
           
            if(window.wishlistMetafields.show_add_to_cart_btn == 0){
                atcButtonHtml = '';
            }
        }else{

           if(product.variants.length > 1){
            var selection_html = ` <span class="flex gap-2 text-xs text-[#D49098] whitespace-nowrap productdrawer-variant-container">`


                product.variants.forEach((variant,index)=>{
                  if(variant.title != 'Default Title'){
                    var cls = "";
                    if(!variant.available){
                    cls = "ctm_disabled ";
                    
                    }
                    if(index == 0){
                      cls += ' active-variant' 
                    }
                    selection_html += 
                      `<div class="flex justify-center px-2.5 py-1 rounded-3xl border border-[#D49098] bg-opacity-60 font-next-art-regular sm:text-base text-xs productdrawer-variant cursor-pointer ${cls}" data-id="${variant.id}">
                       ${variant.title}
                        <span class="hidden productdrawer-product-price">
                         <span class="productdrawer-product-price-discount">${(formatMoney(variant.price)).replace('₹','')}</span>
                          <span class="productdrawer-product-price-original">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                        </span>
                      </div>`
                  }
                })          

           selection_html += `</span><span class="flex gap-2 text-xs whitespace-nowrap productdrawer-variant-price-container">`;

           product.variants.forEach((variant,index)=>{
            if(variant.title != 'Default Title'){
              if(index == 0){
                selection_html += `  <span class="product-price-information flex sm:gap-2 gap-1 start sm:items-end items-center price sale is-visible" data-id="${variant.id}">
                       
                          <span class="lg:text-2xl md:text-lg text-base capitalize font-next-art-bold new-price">${(formatMoney(variant.price)).replace('₹','')}</span>`
                  
                       if(variant.compare_at_price > variant.price){
                         selection_html += `   <span class="sm:text-lg text-sm text-zinc-500 font-next-art-regular line-through old-price">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                        
                          
                         
                          <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                              &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                            </span> `;
                       } 
                       
                       selection_html += `
                        <br>   
                    </span>`
                }else{
                  selection_html += `  <span class="product-price-information flex sm:gap-2 gap-1 start sm:items-end items-center price sale" data-id="${variant.id}">
                         
                            <span class="lg:text-2xl md:text-lg text-base capitalize font-next-art-bold new-price">${(formatMoney(variant.price)).replace('₹','')}</span>`
                    
                         if(variant.compare_at_price > variant.price){
                           selection_html += `   <span class="sm:text-lg text-sm text-zinc-500 font-next-art-regular line-through old-price">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                          
                            
                           
                            <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                                &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                              </span> `;
                         } 
                         
                         selection_html += `
                          <br>   
                      </span>`
                }
              }
            }) 

       
          
           selection_html +=  `</span>
                <button type="button" class="tt-product-atc-main btn product__submit__add shopify-payment-button__button--unbranded atc-btn cstm_atd_all_page justify-center sm:px-5 px-2 py-2.5 sm:text-lg text-sm sm:h-[50px] font-bold text-white whitespace-nowrap bg-gradient-to-l from-[#AD5162] to-[#D49098] hover:bg-gradient-to-br rounded-[43px] max-md:px-5" disabled data-id=${product.id}>
                      <span data-add-to-cart-text="">
                      ${oosText}
                     </span>
                </button>
            `; 
            atcButtonHtml = selection_html;
          }else{

               var selection_html = ` <span class="flex gap-2 text-xs text-[#D49098] whitespace-nowrap productdrawer-variant-container">`


                product.variants.forEach((variant,index)=>{
                  if(variant.title != 'Default Title'){
                    var cls = "";
                    if(!variant.available){
                    cls = "ctm_disabled ";
                    }
                   if(index == 0){
                      cls += ' active-variant' 
                    }
                    
                    selection_html += 
                      `<div class="flex justify-center px-2.5 py-1 rounded-3xl border border-[#D49098] bg-opacity-60 font-next-art-regular sm:text-base text-xs productdrawer-variant cursor-pointer ${cls}" data-id="${variant.id}">
                       ${variant.title}
                        <span class="hidden productdrawer-product-price">
                         <span class="productdrawer-product-price-discount">${(formatMoney(variant.price)).replace('₹','')}</span>`;
                        if(variant.compare_at_price > variant.price){
                          selection_html += `
                          <span class="productdrawer-product-price-original">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                          <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                            &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                          </span>`
                        }
                         
                         selection_html += `  
                        </span>
                      </div>`
                  }
                })          

           selection_html += `</span><span class="flex gap-2 text-xs whitespace-nowrap productdrawer-variant-price-container">`;

           product.variants.forEach((variant,index)=>{
            if(variant.title != 'Default Title'){
               if(index == 0){
                 selection_html += `  <span class="product-price-information flex sm:gap-2 gap-1 start sm:items-end items-center price sale is-visible" data-id="${variant.id}">
                   
                      <span class="lg:text-2xl md:text-lg text-base capitalize font-next-art-bold new-price">${(formatMoney(variant.price)).replace('₹','')}</span>
                    
                      <span class="sm:text-lg text-sm text-zinc-500 font-next-art-regular line-through old-price">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                    
                      
                     
                      <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                          &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                        </span> 
                    <br>   
                </span>`
               }else{

                 selection_html += `  <span class="product-price-information flex sm:gap-2 gap-1 start sm:items-end items-center price sale" data-id="${variant.id}">
                   
                      <span class="lg:text-2xl md:text-lg text-base capitalize font-next-art-bold new-price">${(formatMoney(variant.price)).replace('₹','')}</span>
                    
                      <span class="sm:text-lg text-sm text-zinc-500 font-next-art-regular line-through old-price">${(formatMoney(variant.compare_at_price)).replace('₹','')}</span>
                    
                      
                     
                      <span class="flex-auto font-next-art-bold sm:text-base text-xs bg-gradient-to-l from-[#AD5162] to-[#D49098] inline-block text-transparent bg-clip-text discount__percentage__grid">
                          &nbsp;${Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price)*100)}%Off
                        </span> 
                    <br>   
                </span>`
                 
               } 
              }
            }) 
            selection_html +=  `</span>
                <button type="button" class="tt-product-atc-main btn product__submit__add shopify-payment-button__button--unbranded atc-btn cstm_atd_all_page justify-center sm:px-5 px-2 py-2.5 sm:text-lg text-sm sm:h-[50px] font-bold text-white whitespace-nowrap bg-gradient-to-l from-[#AD5162] to-[#D49098] hover:bg-gradient-to-br rounded-[43px] max-md:px-5" disabled data-id=${product.id}>
                      <span data-add-to-cart-text="">
                      ${oosText}
                     </span>
                </button>
            `; 
            atcButtonHtml = selection_html;
          }
          
            if(window.wishlistMetafields.show_oos_btn == 0){
                atcButtonHtml = '';
            }
        }
        let qtyHtml = '<input class="tt-qty-input" name="tt-quantity" type="hidden" value=1 >';
        if(window.wishlistMetafields.qty_enable == 1){
            qtyHtml = `
            <div class="tt-qty-input">
                <p class="tt-qty-label">Quantity</p>
                <div class="tt-qty-input-inner">
                    <button class="tt-qty-count tt-qty-count--minus" data-action="minus" type="button">-</button>
                    <input class="tt-product-qty" type="number" name="tt-quantity" min="1" value="1">
                    <button class="tt-qty-count tt-qty-count--add" data-action="add" type="button">+</button>
                </div>
            </div>
            `;
        }

        let vendorHtml = '';
        if(window.wishlistMetafields.show_vendor_name == 1){
            vendorHtml = `
                <div class="tt-product-vendor-text">
                    ${product.vendor}
                </div>
            `;
        }
        let productRemoveBtn = `
            <div class="tt-product-remove-wishlist" data-id=${product.id}>
                ${wishlistPopupCloseIcon}
            </div>
        `;
        if(window.isWishlistSharedPage){
            productRemoveBtn = '';
        }
        var review = $('.ctm_review_divs[data-handle="'+product.handle+'"]').html();
        var badge = $('.ctm_badge_divs[data-handle="'+product.handle+'"]').html();
        if($('.ctm_badge_divs[data-handle="'+product.handle+'"]').length == 0){
          badge = '';
        }
        if(review == undefined){
          review = '';
        }
        let productHtml = `
            ${badge}  
            <a href="${product.url}" class="tt-image-a">
                <div class="tt-image-wrap">
                    <img src="${product.featured_image}" alt="${product.title}" />
                </div>
            </a>
            <div class="tt-product-content">
                ${vendorHtml}
                <a href="${product.url}" class="tt-product-title">
                  <p class="product__grid__title cstm_title_change sm:text-lg text-base tracking-wider font-next-art-regular">${product.title}</p>  
                </a>
                ${review}
                <div class="tt-product-price-wrap hidden">
                    <span>${formatMoney(product.variants[0].price)}</span>
                </div>
                <select class="${defaultVariant ? 'tt-hide' : ''}">
                    ${variantHtml}
                </select>
                <div class="tt-qty-selector">
                    ${qtyHtml}
                </div>
                <div class="tt-product-action">
                <div class="tt-atc-button-wrap product-information">
                    ${atcButtonHtml}
                </div>
                ${productRemoveBtn}
            </div>
            </div>
            <div class='tt-error-msg'></div>
            
        `;
        currenrProduct.innerHTML = productHtml;
        fetchProductDetails(products,flag);
    }else{
        window.ttWishlistClickEvents();
        if(flag){
            let allTrendingEle = document.querySelectorAll(".super-wishlist-trending-widget .swiper");
            if(allTrendingEle.length > 0){
                let firstEle = allTrendingEle[0];
                let firstParent = firstEle.closest('.super-wishlist-trending-widget');
                let slideDesk = Number(firstParent.getAttribute('data-desktop-row'));
                let slideMob = Number(firstParent.getAttribute('data-mobile-row'));
                let slideArrow = firstParent.getAttribute('data-arrow');
                let slideAuto = firstParent.getAttribute('data-auto-rotate');
                let sliderSettings = {
                    slidesPerView: slideMob,
                    loop: false,
                    breakpoints: {
                        300: {
                          slidesPerView: slideMob
                        },
                        767: {
                          slidesPerView: slideDesk
                        }
                    }
                };
                if(slideAuto){
                    sliderSettings['autoplay'] = {
                        delay: 4000,
                    };
                }
                allTrendingEle.forEach(ele=>{
                    let mainParent = ele.closest('.super-wishlist-trending-widget');
                    mainParent.style.opacity = 1;
                    if(slideArrow){
                        sliderSettings['navigation'] = {
                            nextEl: ele.querySelector('.swiper-button-next'),
                            prevEl: ele.querySelector('.swiper-button-prev'),
                        };
                    }
                    new Swiper(ele, sliderSettings);
                })
            }
        }
       $('.tt-tab-content-wrap .productdrawer-variant.active-variant').trigger('click'); 
    }

    
    
}
// API call START
const getCategoriesApi = async () => {
    let url = window.wishlistUrl+'get/all?customer_id='+window.customerId;
    let getCategories = await fetch(url, {
        method: 'GET',
        headers:{
            shop: window.shop_domin
        }
    })
    getCategories = await getCategories.json();
    
    window.getCategoriesData = getCategories;
    return getCategories;
}
const getCategoriesDetailsApi = async () => {
    let url = window.wishlistUrl+'get/product-details?customer_id='+window.customerId;
    let getCategories = await fetch(url, {
        method: 'GET',
        headers:{
            shop: window.shop_domin
        }
    })
    getCategories = await getCategories.json();
    return getCategories;
}
const addProductInCategoryApi = async (catId,id) => {
    let data = {
        "customer_id": window.customerId,
        "category_id": catId,
        "product_id":id
    };
    let addTowish = await fetch(window.wishlistUrl+'category/product-add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'shop':  window.shop_domin
      },
      body: JSON.stringify(data)
    })
    addTowish = await addTowish.json();
    return addTowish;
}
const removeProductApi = async (id) => {
    let data = {
        "customer_id": window.customerId,
        "product_id":id
    };
    let removeProduct = await fetch(window.wishlistUrl+'category/product-delete', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'shop':  window.shop_domin
      },
      body: JSON.stringify(data)
    })
    removeProduct = await removeProduct.json();
    return removeProduct;
}
const removeCategoryApi = async (id) => {
    let data = {
        "customer_id": window.customerId,
        "category_id":id
    };
    let removeCategory = await fetch(window.wishlistUrl+'category/delete', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'shop':  window.shop_domin
      },
      body: JSON.stringify(data)
    })
    removeCategory = await removeCategory.json();
    return removeCategory;
}
const createCategoryApi = async (catName) => {
    let data = {
        "customer_id": window.customerId,
        "category_name": catName,
        "customer_email":window.customerEmail,
        "customer_name":window.customerName
    };
    let createCat = await fetch(window.wishlistUrl+'category/create-update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'shop': window.shop_domin
      },
      body: JSON.stringify(data)
    })
    createCat = await createCat.json();
    return createCat;
}
const cartCountApi = async () => {
    let url = window.wishlistUrl+'analytics';
    let data = {
        "cart_count":1
    };
    let cartCount = await fetch(url, {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    })
    cartCount = await cartCount.json();
    return cartCount;
}
const pageCountApi = async () => {
    let url = window.wishlistUrl+'analytics';
    let data = {
        "page_count":1
    };
    let pageCount = await fetch(url, {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    })
    pageCount = await pageCount.json();
    return pageCount;
}
const submitVoteApi = async (pId,flag) => {
    let url = window.wishlistUrl+'product-vote';
    let data = {
        "customer_id":window.customerId,
        "product_id":pId,
        "vote_count":flag ? 1 : 0
    };
    let voteData = await fetch(url, {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    })
    voteData = await voteData.json();
    return voteData;
}
const getVoteDataApi = async (pId) => {
    let url = window.wishlistUrl+'product-vote?product_id='+pId;
    let getVoteData = await fetch(url, {
        method: 'GET',
        headers:{
            shop: window.shop_domin
        }
    })
    getVoteData = await getVoteData.json();
    return getVoteData;
}
const getCustomerVoteDataApi = async (pId) => {
    let url = window.wishlistUrl+'product-vote?product_id='+pId+'&customer_id='+window.customerId;
    let getVoteData = await fetch(url, {
        method: 'GET',
        headers:{
            shop: window.shop_domin
        }
    })
    getVoteData = await getVoteData.json();
    return getVoteData;
}
const trendingApi = async () => {
    let url = window.wishlistUrl+'trending-wishlist';
    let trendingData = await fetch(url, {
        method: 'GET',
        headers:{
            shop: window.shop_domin
        }
    })
    trendingData = await trendingData.json();
    return trendingData;
}
const removeFromCartApi = async = (id) => {
    let updates = {};
    updates[id] = 0;
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
    })
    .then(response => {
        return response.json();
    }).then(res=>{
        window.location.reload();
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}
// API call END
// Ajax cart
const ajaxAddtocart = async (items) => {
    let add = await fetch('/cart/add.js',{
        method:"POST",
        headers: {
            "Content-Type": "application/json"
        },
        body:JSON.stringify({items})
    })
    add = await add.json();
    return add;
}
// common function END
class WishlistPDP{
    constructor(){
        this.storeId = window.shop_domin;
        this.wishlistMeta = window.wishlistMetafields;
        // this.wishlistMeta['category_enable'] = true;
        this.customerExist = window.customerExist;
        this.customerName = window.customerName;
        this.customerEmail = window.customerEmail;
        // this.productId = custom.productId;
        // this.productHandle = custom.productHandle;
        this.wishlistUrl = window.wishlistUrl;
        this.wishlistPageUrl = '/apps/wishlist/wishlist-landing';
        window.isWishlistSharedPage = false;
        if(this.customerExist){
          this.customerId = window.customerId;
        }
        if(!this.customerExist){
            const searchParams = new URLSearchParams(window.location.search);
            if(searchParams.has('q') && window.location.pathname.includes('wishlist-share')){
                window.isWishlistSharedPage = true;
                this.customerExist = true;
                window.customerExist = true;
                this.customerId = Number(searchParams.get('q'));
                window.customerId = this.customerId;
            }
        }
        // window.wishlistMetafields.trending.trending_layout = 'grid';
        // this.wishlistMeta.trending.trending_layout = 'grid';
        this.init();
        if(this.wishlistMeta.show_trending_wishlist == '1' || this.wishlistMeta.show_trending_wishlist == 1){
            this.trendingWishlistSetup();
        }
        document.addEventListener("click",(e)=>{
            if(e.target){
                if(e.target.classList.length > 0  && e.target.classList.contains("tt-wishlist-plp-btn-main")){
                    this.plpButtonClick(e);
                }else if(e.target.closest(".tt-wishlist-plp-btn-main")){
                    this.plpButtonClick(e.target.closest(".tt-wishlist-plp-btn-main"));
                }
            }
        });
    }  
    removeItem = () =>{
      
    }
    clickEvents = () => {
        let wishlist_btn = document.querySelectorAll(".wishlist-pdp-btn-main .wishlist-pdp-btn-wrap");
        if (wishlist_btn.length > 0) {
            wishlist_btn.forEach(item => {
                item.removeEventListener("click", this.pdpButtonClick);
                item.addEventListener("click", this.pdpButtonClick);
            })
        }
        // let plp_wishlist_btn = document.querySelectorAll(".tt-wishlist-plp-btn-main .wishlist-plp-btn-wrap");
        // if (plp_wishlist_btn.length > 0) {
        //     plp_wishlist_btn.forEach(item => {
        //         item.removeEventListener("click", this.plpButtonClick);
        //         item.addEventListener("click", this.plpButtonClick);
        //     })
        // }
        let categoryPopupClose = document.querySelector(".wishlist-create-category-popup .tt-category-close");
        if (categoryPopupClose) {
            categoryPopupClose.removeEventListener("click", this.categoryPopupShow);
            categoryPopupClose.addEventListener("click", ()=>this.categoryPopupShow(true));
        }
        let addProduct = document.querySelectorAll('.wishlist-create-category-popup .tt-form-group .tt-add-wishlist');
        addProduct.forEach(ele=>{
            ele.removeEventListener("click",this.addProductInCategory);
            ele.addEventListener("click",this.addProductInCategory);
        })
        let createCategory = document.querySelector('.wishlist-create-category-popup .tt-form-new-group .tt-add-wishlist');
        if(createCategory){
            createCategory.removeEventListener("click",this.createCategoryEvent);
            createCategory.addEventListener("click",this.createCategoryEvent);
        }
        let wishlistBtns = [".wishlist-floting-btn-wrap",".wishlist-page-widget"];
        wishlistBtns.forEach(btnClass=>{
            let btnSelectors = document.querySelectorAll(btnClass);
            btnSelectors.forEach(ele=>{
                ele.removeEventListener("click",this.wishlistBtnEvent);
                ele.addEventListener("click",this.wishlistBtnEvent);
            })
        });
        let tabEles = document.querySelectorAll('.tt-tab-header-wrap .tt-tab-title');
        tabEles.forEach(ele=>{
            ele.removeEventListener("click",this.tabChangeEvent);
            ele.addEventListener("click",this.tabChangeEvent);
        });
        let detailsPopupClose = document.querySelector(".tt-wishlist-details-popup .tt-details-close");
        if(detailsPopupClose){
            detailsPopupClose.removeEventListener("click",this.detailsPopupCloseEvent);
            detailsPopupClose.addEventListener("click",this.detailsPopupCloseEvent);
        }
        let detailsPopupOverlay = document.querySelector(".tt-wishlist-details-popup .tt-popup-overlay");
        if(detailsPopupOverlay){
            detailsPopupOverlay.removeEventListener("click",this.detailsPopupCloseEvent);
            detailsPopupOverlay.addEventListener("click",this.detailsPopupCloseEvent);
        }
        let shareButton = document.querySelector(".tt-wishlist-share-btn");
        if(shareButton){
            shareButton.removeEventListener("click",this.shareButtonEvent);
            shareButton.addEventListener("click",e=>this.shareButtonEvent());
        }
        let sharePopupClose = document.querySelector(".tt-share-wishlist-popup .tt-share-wishlist-close");
        if(sharePopupClose){
            sharePopupClose.removeEventListener("click",this.shareButtonEvent);
            sharePopupClose.addEventListener("click",e=>this.shareButtonEvent(true));
        }
        let sharePopupOverlay = document.querySelector(".tt-share-wishlist-popup .tt-popup-overlay");
        if(sharePopupOverlay){
            sharePopupOverlay.removeEventListener("click",this.shareButtonEvent);
            sharePopupOverlay.addEventListener("click",e=>this.shareButtonEvent(true));
        }
        let removeCategoryBtns = document.querySelectorAll(".tt-wishlist-details-main .tt-category-remove");
        removeCategoryBtns.forEach(ele=>{
            ele.removeEventListener("click",this.removeCategoryEvent);
            ele.addEventListener("click",(e)=>{
                let that = e.currentTarget;
                this.removeCategoryEvent(that);
            });
        });
        let removeProductBtns = document.querySelectorAll(".tt-wishlist-details-main .tt-product-remove-wishlist");
        removeProductBtns.forEach(ele=>{
            ele.removeEventListener("click",this.removeProductEvent);
            ele.addEventListener("click",(e)=>{
                let that = e.currentTarget;
                this.removeProductEvent(that,()=>{
                  let parent = e.target.closest('.tt-product-list');
                  if(parent){
                    // if(window.wishlistMetafields.remove_product_after_cart == 1){
                      parent.remove();                        
                      var len = document.querySelectorAll('.tt-product-list').length;
                      $('.wishlist-page-widget .wishlist-total-count').text(len);
                      if(len == 0){
                        window.wishlistInit();
                      }
                    // }
                  }
                });
            });
        });
        let addToCartBtns = document.querySelectorAll(".tt-product-list .tt-product-atc-main:not(.ctm_selection_btn)");
        addToCartBtns.forEach(ele=>{
            ele.removeEventListener("click",this.addToCartEvent);
            ele.addEventListener("click",(e)=>{
                let that = e.currentTarget;
                this.addToCartEvent(that, ()=>{
                  let parent = e.target.closest('.tt-product-list');
                  if(parent){
                    if(window.wishlistMetafields.remove_product_after_cart == 1){
                      parent.remove();  
                    }
                  }
                });
            });
        });
        let voteBtns = document.querySelectorAll('.wishlist-pdp-btn-main .tt-vote-btn-wrap');
        voteBtns.forEach(ele=>{
            ele.removeEventListener("click",this.voteButtonEvent);
            ele.addEventListener("click",this.voteButtonEvent);
        });
        let copyShareBtn = document.querySelectorAll('.ttcopybtn');
        copyShareBtn.forEach(ele=>{
            ele.removeEventListener("click",this.copyButtonEvent);
            ele.addEventListener("click",this.copyButtonEvent);
        });
        let qtyButtons = document.querySelectorAll('.tt-product-list .tt-qty-count');
        qtyButtons.forEach(ele=>{
            ele.removeEventListener("click",this.qtyClickEvent);
            ele.addEventListener("click",this.qtyClickEvent);
        })
        // changeEvents
        let qtyInput = document.querySelectorAll('.tt-product-list .tt-product-qty');
        qtyInput.forEach(ele=>{
            ele.removeEventListener("change",this.qtyInputChangeEvent);
            ele.addEventListener("change",(e)=>{
                let that = e.currentTarget;
                this.qtyInputChangeEvent(that);
            });
        })
        let variantChangeSelect = document.querySelectorAll(".tt-wishlist-details-main .tt-product-content select");
        variantChangeSelect.forEach(ele=>{
            ele.removeEventListener("change",this.variantChangeEvent);
            ele.addEventListener("change",(e)=>{
                let that = e.currentTarget;
                this.variantChangeEvent(that);
            });
        });
        
    }
    // wishlist all click event function START
    pdpButtonClick = (e)=>{
        let that = e.currentTarget;
        let parent = that.closest('.wishlist-pdp-btn-main');
        let id = parseInt(parent.getAttribute('data-pid'));
        let handle = parent.getAttribute('data-handle');
        let category_enable = this.wishlistMeta.category_enable;
        // this.getCategories(id,handle);
        if(this.customerExist){
            if (that.classList.contains('active')) {
                // window.location.href = this.wishlistPageUrl;
                this.deleteProduct(id);
            }else if(category_enable){
                // this.getCategories(id,handle);
                this.categoryPopupShow();
                let popupWrap = document.querySelector(".wishlist-create-category-popup-main");
                popupWrap.setAttribute('data-pid',id);
                popupWrap.setAttribute('data-handle',handle);
            }
            else{
                this.addProductInWithoutCategory(id,handle);
            }
        }else if(window.wishlistMetafields.guest_wishlist == 1){
            if (that.classList.contains('active')) {
                this.deleteProductLocal(id);
            }
            else{
                this.addToWishlistLocal(id,handle);
            }
        }else{
            location.href = '/account/login';
        }
    }
    plpButtonClick = (e)=>{
        let that = e.currentTarget;
        let parent = e;
        if(!that){
            that = e.querySelector(".wishlist-plp-btn-wrap");   
        }else{
            parent = that.closest('.tt-wishlist-plp-btn-main');
        }
        if(parent.classList.contains('tt-cart-btn')){
            that.querySelectorAll('span')?.forEach(ele=>{
                ele.innerHTML = 'Saving...';
            })  
        }
        let isCartProduct = false;
        let vId = ''; 
        let category_enable = this.wishlistMeta.category_enable;
        if(parent.classList.contains('tt-cart-btn')){
            vId = parseInt(parent.getAttribute('data-vid'));
            isCartProduct = true;
        }
        let id = parseInt(parent.getAttribute('data-pid'));
        let handle = parent.getAttribute('data-handle');
        if(this.customerExist){
            if (!isCartProduct && that.classList.contains('active')) {
                this.deleteProduct(id);
            }
            else{
                if(isCartProduct){
                    this.addProductInSaved(id,vId,handle);
                }else if(category_enable){
                    this.categoryPopupShow();
                    let popupWrap = document.querySelector(".wishlist-create-category-popup-main");
                    popupWrap.setAttribute('data-pid',id);
                    popupWrap.setAttribute('data-handle',handle);
                }else{
                    this.addProductInWithoutCategory(id,handle);
                }
            }
        }else if(window.wishlistMetafields.guest_wishlist == 1){
            if (!isCartProduct &&  that.classList.contains('active')) {
                this.deleteProductLocal(id);
            }
            else{
                this.addToWishlistLocal(id,handle);
                if(isCartProduct){
                    removeFromCartApi(vId);
                }
            }
        }else{
            location.href = '/account/login';
        }
    }
    addProductInSaved = async (id,vId,handle) => {
        if(window.getCategoriesData){
            let data = window.getCategoriesData.data;
            let catId = '';
            data.forEach(ele=>{
                if(ele.category_name == "Save for later"){
                    catId = ele.category_id;
                }
            })
            if(catId == ''){
                let createCat = await createCategoryApi("Save for later");
                if(createCat.status == 200){
                    let getCategories = await getCategoriesApi();
                    getCategories?.data?.forEach(ele=>{
                        if(ele.category_name == "Save for later"){
                            catId = ele.category_id;
                        }
                    })
                    if(id && catId){
                        let addProductData = await addProductInCategoryApi(catId,id);
                        if(addProductData.status == 200){
                            removeFromCartApi(vId);
                        }
                    }
                }
            }
        }
    }
    addProductInWithoutCategory = async (id,handle) => {
        if(window.getCategoriesData){
            let data = window.getCategoriesData.data;
            let catId = '';
            data.forEach(ele=>{
                if(ele.category_name == "Default Category"){
                    catId = ele.category_id;
                }
            })
            if(catId == ''){
                let createCat = await createCategoryApi("Default Category");
                if(createCat.status == 200){
                    let getCategories = await getCategoriesApi();
                    getCategories?.data?.forEach(ele=>{
                        if(ele.category_name == "Default Category"){
                            catId = ele.category_id;
                        }
                    })
                    if(id && catId){
                        let addProductData = await addProductInCategoryApi(catId,id);
                        if(addProductData.status == 200){
                            this.categoryPopupShow(true);
                            showToastMsg(handle,true);
                            this.getCategoryAllData();
                            wishlistContent();
                        }
                    }
                }
            }else{
                let getCategories = await getCategoriesApi();
                getCategories?.data?.forEach(ele=>{
                    if(ele.category_name == "Default Category"){
                        catId = ele.category_id;
                    }
                })
                if(id && catId){
                    let addProductData = await addProductInCategoryApi(catId,id);
                    if(addProductData.status == 200){
                        this.categoryPopupShow(true);
                        showToastMsg(handle,true);
                        this.getCategoryAllData();
                        wishlistContent();
                    }
                }
            }
        }
    }
    copyButtonEvent = (e) => {
        let that = e.target;
        let parent = that.closest('.tt-share-input-url');
        let copyUrl = parent.querySelector('.tt-share-input')?.value;
        navigator.clipboard.writeText(copyUrl);
        that.classList.add('active');
    }
    qtyClickEvent = (e) => {
        let that = e.target;
        let parent = that.closest(".tt-qty-input");
        let inputEle = parent.querySelector('.tt-product-qty');

        let qtyMin = parseInt(inputEle.getAttribute('min'));
        let actionType = that.getAttribute('data-action');
		let qty = parseInt(inputEle.value);

		if (actionType == "add") {
			qty += 1;
			if (qty >= qtyMin + 1) {
				parent.querySelector('.tt-qty-count--minus').removeAttribute("disabled");
			}
		} else {
			qty = qty <= qtyMin ? qtyMin : (qty -= 1);
			if (qty == qtyMin) {
				parent.querySelector('.tt-qty-count--minus').setAttribute("disabled", true);
			}
		}
		inputEle.value=qty;
    }
    qtyInputChangeEvent = (that) => {
        let parent = that.closest(".tt-qty-input");
        let minusBtn = parent.querySelector('.tt-qty-count--minus');
        let qtyMin = parseInt(that.getAttribute('min'));
		let qty = parseInt(that.value);
		if (isNaN(qty) || qty <= qtyMin) {
            that.value=qtyMin;
            minusBtn.setAttribute("disabled", true);
		} else {
            that.value=qty;
            minusBtn.removeAttribute("disabled");
		}
    }
    voteButtonEvent = async (e) => {
        if(this.wishlistMeta.vote_btn.enable == 0 || !this.wishlistMeta.vote_btn.enable){
            return false;
        }
        if(!this.customerExist){
            return false;
        }
        let that = e.currentTarget;
        let parent = that.closest('.wishlist-pdp-btn-main');
        let pId = parent.getAttribute('data-pid');
        let flag = true;
        if(that.classList.contains('active')){
            flag = false;
        }
        if(flag){
            that.classList.add('active')
        }
        let voteData = await submitVoteApi(pId,flag);
        if(voteData.status == 200){
            this.setupVoteBtn();
        }
    }
    addProductInCategory = async (e) => {
        let that = e.target;
        let parent = that.closest('.wishlist-create-category-popup-main');
        let id = parent.getAttribute('data-pid');
        let handle = parent.getAttribute('data-handle');
        let catId = that.getAttribute('cat-id');
        if(id && catId){
            let addProductData = await addProductInCategoryApi(catId,id);
            if(addProductData.status == 200){
                this.categoryPopupShow(true);
                showToastMsg(handle,true);
                this.getCategoryAllData();
                wishlistContent();
            }
        }
    }
    detailsPopupCloseEvent = () => {
        wishlistPopupOpen(true);
    }
    createCategoryEvent = async (e) => {
        let that = e.target;
        let parent = that.closest('.wishlist-create-category-popup-main');
        let inputEle = parent.querySelector('.tt-form-new-group input');
        let catName = inputEle.value;
        if(catName){
            let createCat = await createCategoryApi(catName);
            if(createCat.status == 200){
                this.createCategory();
            }
        }
    }
    wishlistBtnEvent = () => {
        let module = wishlistMetafields.button_setting.wishlist_module;
        if(module == 'popup' || module == 'drawer' ){
            if(!document.querySelector(".tt-wishlist-landing-page-main")){
                pageCountApi();
                wishlistPopupOpen();
            }
        }else{
            location.href = '/apps/wishlist/wishlist-landing';
        }
    }
    tabChangeEvent = (e) => {
        let that = e.target;
        let tabId = that.getAttribute('data-tab');
        
        let allTabHead = document.querySelectorAll('.tt-tab-header-wrap li');
        let allTabBody = document.querySelectorAll('.tt-tab-content-wrap .tab-content-inner-wrap');
        allTabHead.forEach(ele=>{
            if(ele.getAttribute('data-tab') == tabId){
                ele.classList.add('active');
            }else{
                ele.classList.remove('active');
            }
        })
        allTabBody.forEach(ele=>{
            if(ele.getAttribute('data-tab') == tabId){
                ele.classList.add('active');
            }else{
                ele.classList.remove('active');
            }
        })
    }
    shareButtonEvent = (flag) => {
        let popupWrap = document.querySelector(".tt-share-wishlist-popup");
        if(flag){
            document.body.classList.remove('tt-overflow-hidden');
            popupWrap.classList.remove('active');
        }else{
            document.body.classList.add('tt-overflow-hidden');
            popupWrap.classList.add('active');
        }
    }
    removeCategoryEvent = async (e) => {
        let id = e.getAttribute('data-cid');
        let removeProd = await removeCategoryApi(id);
        if(removeProd.status == 200){
            this.createCategory();
            wishlistContent();
        }
    }
    removeProductEvent = async (e, callback) => {
        let id = e.getAttribute('data-id');
        if(this.customerExist){
            let removeProd = await removeProductApi(id);
            if(removeProd.status == 200){
                this.createCategory();
                // wishlistContent();
                if(callback){
                  callback();
                }
            }
        }else if(window.wishlistMetafields.guest_wishlist == 1){
            this.deleteProductLocal(id);
          if(callback){
                  callback();
                }
        }
    }
    addToCartEvent = async (e, callback) => {
        // e.innerHTML = 'Adding...';
        e.classList.add('is-loading');
        let parent = e.closest('.tt-product-list');
        let pId = e.getAttribute('data-id');
        let variantSelect = parent.querySelector('.tt-product-content select');
        let selectedOption = variantSelect.selectedOptions[0];
        let availability = selectedOption.getAttribute('data-available');
        let id = parseInt(selectedOption.getAttribute('value'));
        let atcText = window.wishlistMetafields.language2.btn_move_to_cart;
        let quantity = parent.querySelector('input[name=tt-quantity]');
        quantity = parseInt(quantity.value);
        if(!(quantity > 1)){
            quantity = 1;
        }
        if(availability && availability == 'true' || availability == true){
            // let items = {
            //     id:id,
            //     quantity:quantity,
            //     properties: {
            //         '_is_wishlist_product': true
            //     }
            // };

          var _this = this;
         
           $.getJSON('/cart',function(cart) {
              var limit = 0;
             var _items = cart.items;
             for(var i = 0; i < _items.length; i++){
               var item = _items[i];
               if(item.variant_id == id){
                 limit += item.quantity;
                 
               }
             }

             var target = e;

               if(limit < 5){

                   $.ajax({
                       type: "post",
                       url: "/cart/add.js",
                       data:{
                          id:parseInt(id),
                          quantity:parseInt(quantity),
                          properties: {
                              '_is_wishlist_product': true
                          }
                       },
                       dataType: "json", 
                       success: function(e) {
      
                       $.getJSON('/cart',function(cart) {
                          $('.add_to_cart_container').addClass('block');
                          $('.add_to_cart_container .quntity_add').text(cart.item_count+' Item | '+formatMoney(cart.total_price));
                          setTimeout(function(e) {
                           $('.add_to_cart_container').removeClass('block');
                          },3000)
                        })
                        
                        $(target).closest('.tt-atc-button-wrap').find('.product-upsell__errors').removeClass('is-visible');
                        $(target).removeClass('ctm_limit_reached');
                        window.cart_this.getCart();
                        cartCountApi();
                        if(window.wishlistMetafields.stay_on_wishlist_after_cart == 1){
                            // target.innerHTML = atcText;
                            target.classList.remove('is-loading');
                            if(_this.customerExist){
                                if(window.isWishlistSharedPage){
                                    return false;
                                }
              
                                if(window.wishlistMetafields.remove_product_after_cart == 1){
                                  let removeProd = removeProductApi(pId);
                                  if(removeProd.status == 200){
                                    if(callback){
                                        callback();
                                    }
                                      // wishlistContent();
                                      // this.createCategory();
                                  } 
                                }
                               
                                if(window.wishlistMetafields.stay_on_wishlist_after_cart == 0){
                                    location.href = '/cart';
                                }
                            }else if(window.wishlistMetafields.guest_wishlist == 1){
                              if(window.wishlistMetafields.remove_product_after_cart == 1){
                               _this.deleteProductLocal(pId); 
                              }
                                // wishlistContent();
                                if(callback){
                                      callback();
                                  }
                            }
                        }else{
                            // target.innerHTML = "Added To Cart";
                            target.classList.remove('is-loading');
                            if(window.wishlistMetafields.stay_on_wishlist_after_cart == 0){
                                location.href = '/cart';
                            }
                        }
                        var len = document.querySelectorAll('.tt-product-list').length;
                        if(len == 0){
                          window.wishlistInit();
                        }
                        if(limit == 4){
                           $(target).closest('.tt-atc-button-wrap').find('.product-upsell__errors').addClass('is-visible');
                          $(target).addClass('ctm_limit_reached'); 
                        } 
                       },
                        error: function(e) {
                          let atc = e;
                          if(atc.status == 422){
                              // parent.querySelector(".tt-error-msg").innerHTML = atc.description;
                              // e.innerHTML = atcText;
                              if(atc.responseJSON.description.indexOf('add more than') > -1){
                                $(target).closest('.tt-atc-button-wrap').find('.product-upsell__errors').addClass('is-visible');
                                $(target).addClass('ctm_limit_reached'); 
                              }
                          }
                        }
                     })
                 
               }else{
                  $(target).closest('.tt-atc-button-wrap').find('.product-upsell__errors').addClass('is-visible');
                  $(target).addClass('ctm_limit_reached'); 
               }
             
             
           })
          
             
        }
    }
    variantChangeEvent = (e) => {
        let parent = e.closest('.tt-product-list');
        let selectedOption = e.selectedOptions[0];
        let price = selectedOption.getAttribute("data-price");
        let priceEle = parent.querySelector(".tt-product-price-wrap span");
        priceEle.innerHTML = formatMoney(price);
    }
    categoryPopupShow = (flag) => {
        let popupWrap = document.querySelector(".wishlist-create-category-popup-main");
        if(flag){
            document.body.classList.remove('tt-overflow-hidden');
            popupWrap.classList.remove('active');
        }else{
            document.body.classList.add('tt-overflow-hidden');
            popupWrap.classList.add('active');
        }
    }
    // wishlist all click event function END
    getCategoryAllData = async (data) => {
        // First get all categories from API.
        let getCategories = data;
        if(!getCategories){
            getCategories = await getCategoriesApi();
        }
        if(getCategories.status != 200){
            return false;
        }
        let available_pro = [];
        if(getCategories.data && getCategories.data.length > 0){
            let pdpButtons = document.querySelectorAll('.wishlist-pdp-btn-main');
            let plpButtons = document.querySelectorAll('.tt-wishlist-plp-btn-main');
            if(getCategories.data.length > 0){
                getCategories.data.forEach((item,i) => {
                    available_pro = available_pro.concat(item.product_ids);
                })
                if(pdpButtons.length > 0){
                    pdpButtons.forEach((item,i) => {
                        let item_id = item.getAttribute('data-pid').toString();
                        if(available_pro.includes(item_id)){
                            item.querySelector('.wishlist-pdp-btn-wrap')?.classList.add('active');
                        }else{
                            item.querySelector('.wishlist-pdp-btn-wrap')?.classList.remove('active');
                        }
                    })
                }
                if(plpButtons.length > 0){
                    plpButtons.forEach((item,i) => {
                        let item_id = item.getAttribute('data-pid').toString();
                        if(available_pro.includes(item_id)){
                            item.querySelector('.wishlist-plp-btn-wrap')?.classList.add('active');
                        }else{
                            item.querySelector('.wishlist-plp-btn-wrap')?.classList.remove('active');
                        }
                    })
                }
            }
            else{
                if(pdpButtons.length > 0){
                    pdpButtons.forEach((item,i) => {
                        item.querySelector('.wishlist-pdp-btn-wrap')?.classList.remove('active');
                    })
                }
                if(plpButtons.length > 0){
                    plpButtons.forEach((item,i) => {
                        item.querySelector('.wishlist-plp-btn-wrap')?.classList.remove('active');
                    })
                }
            }
        }
    }
    fetchProductExistLocal = () => {
        let productsData = getCookie('wishlist');
        let flag = false;
        let curr_pro_id = [];
        let allpro = document.querySelectorAll('.wishlist-pdp-btn-main');
        let plpButtons = document.querySelectorAll('.tt-wishlist-plp-btn-main');
        if(productsData){
            productsData = JSON.parse(productsData);
            productsData.forEach(item =>{
                curr_pro_id.push(item.p_id);
            })
        }
        if(allpro.length > 0){
            allpro.forEach((item,i) => {
                let item_id = parseInt(item.getAttribute('data-pid'));
                if(curr_pro_id.includes(item_id)){
                    item.querySelector('.wishlist-pdp-btn-wrap')?.classList.add('active');
                    flag = true;
                }else{
                    item.querySelector('.wishlist-pdp-btn-wrap')?.classList.remove('active');
                }
            })
        }
        if(plpButtons.length > 0){
            plpButtons.forEach((item,i) => {
                let item_id = parseInt(item.getAttribute('data-pid'));
                if(curr_pro_id.includes(item_id)){
                    item.querySelector('.wishlist-plp-btn-wrap')?.classList.add('active');
                }else{
                    item.querySelector('.wishlist-plp-btn-wrap')?.classList.remove('active');
                }
            })
        }
    }
    addToWishlistLocal = (p_id,p_handle) => {
        let productsData = getCookie('wishlist');
        if(productsData == 0){
          productsData = [];
        }else{
          productsData = JSON.parse(productsData);
        }
        let obj = {
          'p_id': p_id,
          'p_handle': p_handle,
        }
        productsData.push(obj);
        productsData = JSON.stringify(productsData);
        setCookie('wishlist',productsData,100);
        showToastMsg(p_handle,true);
        this.fetchProductExistLocal();
        wishlistContent();
    }
    deleteProduct = async (id) => {
        if(id){
            let removeProd = await removeProductApi(id);
            if(removeProd.status == 200){
                this.getCategoryAllData();
                wishlistContent();
            }
        }
    }
    deleteProductLocal = (id) => {
        // remove product from wishlist local
        let productsData = getCookie('wishlist');
        if(productsData != 0){
            productsData = JSON.parse(productsData);
            let newProductData = productsData.filter(item=>{
                let flag = true;
                if(item.p_id == id){
                    flag = false;
                }
                return flag;
            })
            newProductData = JSON.stringify(newProductData);
            setCookie('wishlist','',0);
            setCookie('wishlist',newProductData,100);
            var url = window.location.href;
            if(url.indexOf('/wishlist-landing') > -1){
              window.wishlistButtonsInit();
            }else{
             this.fetchProductExistLocal();
             wishlistContent(); 
            }
        }
    }
    setButtons = () => {
        if(window.isWishlistSharedPage){
            return false;
        }
        let allPlaceParent = document.querySelectorAll('.wishlist-pdp-btn-main');
        let button_style = this.wishlistMeta.button_style;

        let buttonSty = button_style.btnStyle;
        let buttonStyleClass = getMainButtonClass(buttonSty);

        let buttonText = button_style.btnText;
        let buttonAfterText = button_style.btnTextAfterWishlist;

        let buttonColor = button_style.btnColor;
        let buttonBg = button_style.btnBgColor;
        let buttonAfterColor = button_style.btnColorAfterWishlist;
        let buttonAfterBg = button_style.btnBgColorAfterWishlist;
        allPlaceParent.forEach(ele=>{
            ele.classList.add(buttonStyleClass);
            ele.setAttribute('style',`--tt-main-btn-color:${buttonColor}; --tt-main-btn-bg:${buttonBg}; --tt-main-af-btn-color:${buttonAfterColor}; --tt-main-af-btn-bg:${buttonAfterBg};`)
            let islikeButton = false;
            let voteBtn = '';
            if(this.customerExist && (this.wishlistMeta.vote_btn.enable == 1 || this.wishlistMeta.vote_btn.enable)){
                islikeButton = true;
                voteBtn = `
                    <button type="button" class="tt-vote-btn-wrap">
                        <span class="tt-vote-btn-span tt-vote-init-label">
                            <span class="tt-vote-icon">
                                ${wishlistLikeEmptyIcon}
                            </span>
                            <span class="tt-vote-count">0</span>
                        </span>
                        <span class="tt-vote-btn-span tt-vote-after-label">
                            <span class="tt-vote-icon">
                                ${wishlistLikeFillIcon}
                            </span>
                            <span class="tt-vote-count">0</span>
                        </span>
                    </button>
                `;
            }
            let buttonHtml = `
                <div class="wishlist-pdp-btn-main-wrap">
                    <button type="button" class="wishlist-pdp-btn-wrap ${islikeButton ? '':'full-width'}">
                        <span class="wishlist-btn-content-span wishlist-init-label">
                            <span class="wishlist-icon">
                                ${wishlistEmptyIcon}
                            </span>
                            <span class="tt-btn-text">${buttonText}</span>
                        </span>
                        <span class="wishlist-btn-content-span wishlist-after-label">
                            <span class="wishlist-icon">
                                ${wishlistFillIcon}
                            </span>
                            <span class="tt-btn-text">${buttonAfterText}</span>
                        </span>
                    </button>
                    ${voteBtn}
                </div>
            `;
            ele.innerHTML = buttonHtml;
        })
        if(this.wishlistMeta.button_setting.launch_btn_type == 'floating_btn'){
            let floatingButton = document.createElement('DIV');
            let buttonClass = this.wishlistMeta.button_setting.launch_btn_placement;
            let buttonStyle = this.wishlistMeta.button_setting.launch_btn_style;
            let buttonRadius = this.wishlistMeta.button_setting.launch_btn_radius;
            let buttonColor = this.wishlistMeta.button_setting.launch_btn_text_color;
            let buttonBg =this.wishlistMeta.button_setting.launch_btn_bg_color;
            let buttonText =this.wishlistMeta.button_setting.launch_btn_text;
            floatingButton.setAttribute('class',`wishlist-floating-btn-main ${buttonClass} ${buttonStyle} ${buttonRadius}`);
            floatingButton.setAttribute('style',`--floating-btn-color:${buttonColor}; --floating-btn-bg:${buttonBg}`);
            let buttonHtml = `
                <button type="button" class="wishlist-floting-btn-wrap">
                    <span class="wishlist-icon">
                        ${wishlistEmptyIcon}
                    </span>
                    <span class="wishlist-btn-text">${buttonText}</span>
                </button>
                `;
            floatingButton.innerHTML = buttonHtml;
            document.body.append(floatingButton);
        }
        if(this.customerExist && (this.wishlistMeta.vote_btn.enable == 1 || this.wishlistMeta.vote_btn.enable)){
            this.setupVoteBtn();
        }
        let plpBtnWrap = document.querySelectorAll('.tt-wishlist-plp-btn-main');
        let collectionStyle = window.wishlistMetafields.collection;

        let buttonClass = collectionStyle.icon_position;
        let plpButtonColor = collectionStyle.icon_before_wishlist_color;
        let plpButtonBg = collectionStyle.icon_after_wishlist_color;
        plpBtnWrap.forEach(ele=>{
            if(this.wishlistMeta.save_for_later == 0){
                if(ele.classList.contains('tt-cart-btn')){
                    return false;
                }
            }
            ele.setAttribute('style',`--wishlist-plp-btn-color:${plpButtonColor}; --wishlist-plp-btn-bg:${plpButtonBg}`);
            ele.classList.add('tt-position',buttonClass);
            let buttonHtml = `
                <button class="wishlist-plp-btn-wrap" type="button">
                    <span class="wishlist-btn-content-span wishlist-init-label">
                        ${wishlistEmptyIcon}
                    </span>
                    <span class="wishlist-btn-content-span wishlist-after-label">
                        ${wishlistFillIcon}
                    </span>
                </button>
            `;
            if(this.wishlistMeta.save_for_later == 1 && ele.classList.contains('tt-cart-btn')){
                buttonHtml = `
                <button class="wishlist-plp-btn-wrap" type="button">
                    <span class="wishlist-btn-content-span wishlist-init-label">
                        Save For Later
                    </span>
                    <span class="wishlist-btn-content-span wishlist-after-label">
                        Save For Later
                    </span>
                </button>
            `;
            }
            ele.innerHTML = buttonHtml;
        })
    }
    createCategory = async () => {
        let getCategories = await getCategoriesApi();
        let currentCategoryHtml = '';
        if(getCategories && getCategories.data && getCategories.data.length > 0){
            getCategories.data.forEach(ele=>{
                currentCategoryHtml += `
                    <div class="tt-form-group">
                        <span class="wishlist-p-tag">${ele.category_name}</span>
                        <button type="button" class="tt-btn tt-add-wishlist" cat-id="${ele.category_id}">Add</button>
                    </div>
                `;
            })
        }
        let categoryHtml = `
            <div class="wishlist-create-category-popup">
                <div class="tt-popup-overlay"></div>
                <div class="tt-category-popup">
                    <div class="tt-category-close">${wishlistPopupCloseIcon}</div>
                    <div class="tt-popup-content">
                        <div class="tt-wishlist-form">
                            <div class="tt-form-title">
                                    <p class="wishlist-p-tag">Add this item to a category</p>
                            </div>
                            <div class="tt-cat-wrap">
                                ${currentCategoryHtml}
                            </div>
                            <div class="tt-form-new-group">
                                <input type="text" name="wishlistname" placeholder="Create New Category">
                                <button type="button" class="tt-btn tt-add-wishlist">Create Category</button>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        `;
        let divEle = document.createElement('DIV');
        divEle.setAttribute('class','wishlist-create-category-popup-main');
        if(document.querySelector('.wishlist-create-category-popup-main')){
            document.querySelector('.wishlist-create-category-popup-main').innerHTML = categoryHtml;
        }else{
            divEle.innerHTML = categoryHtml;
            document.body.append(divEle);
        }
        this.clickEvents();
        this.getCategoryAllData(getCategories);
    }
    setupVoteBtn = async () => {
        let wishlistMainBtn = document.querySelectorAll('.wishlist-pdp-btn-main');
        if(wishlistMainBtn.length > 0){
            let pId = wishlistMainBtn[0].getAttribute('data-pid');
            let voteCustomerData = await getCustomerVoteDataApi(pId);
            if(voteCustomerData.status == 200){
                let voteBtnStyle = this.wishlistMeta.vote_btn;
                let buttonColor = voteBtnStyle.btn_color;
                let buttonBg = voteBtnStyle.btn_bg;
                let buttonAfterColor = voteBtnStyle.after_btn_color;
                let buttonAfterBg = voteBtnStyle.after_btn_bg;
                wishlistMainBtn.forEach(ele=>{
                    let voteBtn = ele.querySelector('.tt-vote-btn-wrap');
                    voteBtn.setAttribute('style',`--tt-vote-btn-color:${buttonColor}; --tt-vote-btn-bg:${buttonBg}; --tt-vote-af-btn-color:${buttonAfterColor}; --tt-vote-af-btn-bg:${buttonAfterBg};`)
                    let voteCountText = voteBtn.querySelectorAll('.tt-vote-count');
                    voteCountText.forEach(innerEle=> {
                        innerEle.innerHTML = voteCustomerData.data;
                    })
                    if(voteCustomerData.customerVote == 1){
                        voteBtn.classList.add('active');
                    }else{
                        voteBtn.classList.remove('active');
                    }
                })
            }

        }
    }
    settingsBasedContent = () => {
        let pageTitle = window.wishlistMetafields.language2.page_title;
        let isEle = document.querySelector(window.wishlistPageSelector);
        let mainEle = document.querySelector(".tt-wishlist-details-main");
        if(!(isEle)){
            isEle = document.querySelector(window.wishlistSharedPageSelector);
            if(isEle){
                window.isWishlistSharedPage = true;
            }
        }
        if(pageTitle){
            document.querySelector('.tt-details-title p').innerHTML = pageTitle;
        }
        if(isEle){
            pageCountApi();
            isEle.append(mainEle);
        }
        if(window.isWishlistSharedPage){
            return false;
        }
        let shareButton = document.querySelector(".tt-wishlist-share-btn");
        if(window.wishlistMetafields.share_wishlist == 1 && window.customerExist){
            let shareData = window.wishlistMetafields.share_wishlist_data;            
            let sharePopup = document.querySelector('.tt-share-wishlist-popup');
            shareButton.classList.remove('tt-hide');
            document.body.append(sharePopup);
            if(shareData.facebook == 0){
                let fbEle = sharePopup.querySelector('.tt-fb-share');
                fbEle.classList.add('tt-hide');
            }
            if(shareData.twitter == 0){
                let fbEle = sharePopup.querySelector('.tt-twitter-share');
                fbEle.classList.add('tt-hide');
            }
            if(shareData.whatsapp == 0){
                let fbEle = sharePopup.querySelector('.tt-wp-share');
                fbEle.classList.add('tt-hide');
            }
            if(shareData.email == 0){
                let fbEle = sharePopup.querySelector('.tt-email-share');
                fbEle.classList.add('tt-hide');
            }
            if(shareData.copy_link == 0){
                let fbEle = sharePopup.querySelector('.tt-share-copy');
                fbEle.classList.add('tt-hide');
            }
        }
    }
    trendingWishlistSetup = async () => {
        let selector = document.querySelectorAll('.super-wishlist-trending-widget');
        if(this.wishlistMeta.show_trending_wishlist == 0){
            return false;
        }
        if(selector.length == 0){
            return false;
        }
        let trendingData = await trendingApi();
        if(trendingData.status == 200 && trendingData.data && trendingData.data.length > 0){
            let trendingSettings = this.wishlistMeta.trending;
            let trending_layout = trendingSettings.trending_layout;
            let trending_title = trendingSettings.trending_title;
            let trending_desktop_per_row = trendingSettings.trending_desktop_per_row;
            let trending_mobile_per_row = trendingSettings.trending_mobile_per_row;
            let trending_slider_arrows = trendingSettings.trending_slider_arrows;
            let trending_slider_auto_rotate = trendingSettings.trending_slider_auto_rotate;
            let productsHtml = '';
            trendingData.data.forEach(ele=>{
                productsHtml += `
                    <div class="tt-product-list swiper-slide" data-handle="${ele.handle}">
                    </div>
                `;
            })
            
            let trendingHtml = `
                <div class="tt-container">
                    <div class="tt-wishlist-trending-wrap">
                        <div class="tt-trending-title-wrap">
                            <p>${trending_title}</p>
                        </div>
                        <div class="tt-wishlist-trending-inner-wrap swiper">
                            <div class="swiper-wrapper">
                                ${productsHtml}
                            </div>
                            <div class="swiper-button swiper-button-next">
                            </div>
                            <div class="swiper-button swiper-button-prev">
                            </div>
                        </div>
                    </div>
                </div>
            `;
            selector.forEach(ele=>{
                ele.classList.add(trending_layout);
                ele.setAttribute('data-desktop-row',trending_desktop_per_row);
                ele.setAttribute('data-mobile-row',trending_mobile_per_row);
                ele.setAttribute('data-arrow',trending_slider_arrows);
                ele.setAttribute('data-auto-rotate',trending_slider_auto_rotate);
                if(trending_layout == 'slider'){
                    ele.setAttribute('style',`--tt-wishlist-font-multipler:1;opacity:0`);
                }else{
                    ele.setAttribute('style',`--tt-wishlist-font-multipler:1`);
                }
                ele.innerHTML = trendingHtml;
            })
            if(trending_layout == 'slider'){
                updateProductContent(true,true);
            }else{
                updateProductContent(false,true);
            }
        }
    }
    init = () => {
        if(window.wishlistMetafields?.trending?.trending_layout == 'slider'){
            // Create a link element for CSS
            let cssLink = document.createElement("link");
            cssLink.rel = "stylesheet";
            cssLink.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
            document.head.appendChild(cssLink);
        
            // Create a script element for JS
            let jsScript = document.createElement("script");
            jsScript.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
            document.body.appendChild(jsScript);
        }
        this.setButtons();
        window.ttWishlistClickEvents = () => {
            this.clickEvents();
        }
        if(this.customerExist){
            // If customer is login then fetch data from API
            // this.findProductExist();
            this.createCategory();
        }else if(window.wishlistMetafields.guest_wishlist == 1){
            // If customer is not login then fetch data from local storage
            this.fetchProductExistLocal();
            this.clickEvents();
        }else{
            this.clickEvents();
        }
        this.settingsBasedContent();
        wishlistContent();
    }
    reButtonsInit = () => {
        this.setButtons();
        if(this.customerExist){
            this.createCategory();
        }else if(window.wishlistMetafields.guest_wishlist == 1){
            this.fetchProductExistLocal();
        }
       var url = window.location.href;
      if(url.indexOf('/wishlist-landing') > -1){
        setTimeout(function(e) {
          
          var len = document.querySelectorAll('.tt-wishlist-details-main .tt-product-list').length;
          $('.ctm_wishlist .wishlist-total-count').text(len)
          if(len == 0){
            document.querySelectorAll(".wishlist-page-widget .wishlist-total-count").forEach(function(e) {
                  e.style.display = "none";
            }) 
          }else{
            document.querySelectorAll(".wishlist-page-widget .wishlist-total-count").forEach(function(e) {
                  e.style.display = "";
            }) 
          }
          
          document.querySelectorAll('.tt-product-list .tt-image-a').forEach(function(e) {
                e.style.height = ''
          })
        
          var newheight = 0;
          document.querySelectorAll('.tt-product-list .tt-image-a').forEach(function(e) {
             if(newheight < e.offsetHeight){
               newheight =  e.offsetHeight; 
             } 
          })
          document.querySelectorAll('.tt-product-list .tt-image-a').forEach(function(e) {
             e.style.height = newheight+"px"
          })
        
          var height = 0;
          document.querySelectorAll('.tt-product-list .tt-product-content .tt-product-title').forEach(function(e) {
               e.style.height = "";
          }) 
          if(document.querySelectorAll('.tt-product-list .tt-product-content .tt-product-title') != undefined || document.querySelectorAll('.tt-product-list .tt-product-content .tt-product-title') != null){
            document.querySelectorAll('.tt-product-list .tt-product-content .tt-product-title').forEach(function(e) {
               if(height < e.offsetHeight){
                 height =  e.offsetHeight; 
               } 
            })
            document.querySelectorAll('.tt-product-list .tt-product-content .tt-product-title').forEach(function(e) {
               e.style.height = height+"px"
            }) 
          }  
    
        },300);
      }else{
        this.settingsBasedContent();
        wishlistContent();
      }
    }
}
let wishlistData = new WishlistPDP;
window.wishlistInit = () => {
    wishlistData.init();
}
window.wishlistButtonsInit = () => {
    wishlistData.reButtonsInit();
}
var url = window.location.href;
if(url.indexOf('/wishlist-landing') > -1){
          
  $(document).on('click','.cart-item__content-inner .tt-wishlist-plp-btn-main .wishlist-plp-btn-wrap.active',function(e) {
     var handle = $(this).closest('.tt-wishlist-plp-btn-main').attr('data-handle');
     $('.tt-wishlist-details-content .tt-product-list[data-handle="'+handle+'"] .tt-product-remove-wishlist').trigger('click'); 
  })
  $(document).on('click','.ctm_selection_btn',function(e) {
    e.preventDefault();
    $(this).closest('.tt-product-action').addClass('active');
    $(this).hide();
    return false;
  });

   $(document).on('click','.tt-atc-button-wrap .radio__button label',function(e) {
     var val = $(this).attr('data-var');
     $(this).closest('.tt-product-list').find('.tt-product-content select').val(val);
     var evt = document.createEvent("HTMLEvents");
     evt.initEvent("change", false, true);
     $(this).closest('.tt-product-list').find('.tt-product-content select')[0].dispatchEvent(evt);
     $(this).closest('.tt-product-list').find('.tt-product-atc-main:not(.ctm_selection_btn)')[0].click();
     var available = $(this).closest('.tt-product-list').find('.tt-product-content select option:selected').attr('data-available');
     console.log(available);
  })

  $(document).on('click',function (e) {
    if ($(e.target).closest(".tt-product-action").length === 0) {
      if($(e.target).closest('.tt-product-list').find('.tt-product-action').hasClass('active')){
       $(e.target).closest('.tt-product-list').find('.tt-product-action').removeClass('active'); 
       $(e.target).closest('.tt-product-list').find('.ctm_selection_btn').show();  
      }
    }
  });

  $(document).on('click','.tt-atc-button-wrap .ctm_disabled',function(e) {
    var language2 = window.wishlistMetafields.language2;
    var sold_out = language2.btn_oos_text;
     var id = parseInt($(this).closest('.tt-product-list').find('.tt-product-content select option:checked').val());
     var target = $(this).closest('.tt-atc-button-wrap').find('.tt-product-atc-main');
    console.log($(this).closest('.tt-product-action').find('.tt-product-atc-main span[data-add-to-cart-text]'),'sold out text');
     $(this).closest('.tt-product-action').find('.tt-product-atc-main span[data-add-to-cart-text]').text(sold_out)
     $(this).closest('.tt-product-action').find('.tt-product-atc-main').addClass('btn_disabled'); 
     target.closest('.tt-atc-button-wrap').find('.product-upsell__errors').removeClass('is-visible');
     target.removeClass('ctm_limit_reached'); 
  })
  $(document).on('click','.tt-atc-button-wrap .productdrawer-variant:not(.ctm_disabled)',function(e) {
     var _this = this;
     var language2 = window.wishlistMetafields.language2;
     var atcText = language2.btn_move_to_cart;
      
     $.getJSON('/cart',function(cart) {
       console.log(cart,'working on cart');
       var id = parseInt($(_this).closest('.tt-product-list').find('.tt-product-content select option:checked').val());
       var limit = 0;
       var _items = cart.items;
       for(var i = 0; i < _items.length; i++){
         var item = _items[i];
         if(item.variant_id == id){
           limit += item.quantity;
           
         }
       }

    
       var target = $(_this).closest('.tt-atc-button-wrap').find('.tt-product-atc-main');
       
       if(limit < 5){
        target.closest('.tt-atc-button-wrap').find('.product-upsell__errors').removeClass('is-visible');
        target.removeClass('ctm_limit_reached'); 
        
       }else{
          target.closest('.tt-atc-button-wrap').find('.product-upsell__errors').addClass('is-visible');
          target.addClass('ctm_limit_reached'); 
          console.log(limit,'working..................',target.closest('.tt-atc-button-wrap').find('.product-upsell__errors'));
       }
       $(_this).closest('.tt-product-action').find('.tt-product-atc-main span[data-add-to-cart-text]').text(atcText)
       $(_this).closest('.tt-product-action').find('.tt-product-atc-main').removeClass('btn_disabled'); 
       console.log($(_this).closest('.tt-product-action'));
     })
  })

  $(document).on('click','.tt-atc-button-wrap .productdrawer-variant',function(e) {
    var id = $(this).attr('data-id');
    $(this).closest('.tt-product-list').find('.tt-product-content > select').val(id).change();  
    $(this).closest('.tt-product-action').find('.product-price-information[data-id="'+id+'"]').addClass('is-visible');
    $(this).closest('.tt-product-action').find('.product-price-information[data-id!="'+id+'"]').removeClass('is-visible')
  })
  
}

